$(function () {

    const swiper = new Swiper('.swiper-container', {
        autoplay: 3000,
        loop: true,
        pagination: '.swiper-pagination',
        paginationClickable: true,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        onInit: function (swiper) {
            swiperAnimateCache(swiper);
            swiperAnimate(swiper);
        },
        onSlideChangeEnd: function (swiper) {
            swiperAnimate(swiper);
        }
    });

    $('.backtotop').click(function () {
        $('body').animate({
            scrollTop: 0
        }, 200);
    });
    $(window).scroll(function () {
        let top = $(this).scrollTop();
        if (top > 300) {
            $('.backtotop').show();
        } else {
            $('.backtotop').hide();
        }
    });


});